<template>
    <div id="app">
        <!-- 立冬礼物弹窗 -->
        <div class="gift-modal" v-if="showGiftModal">
            <div class="gift-content">
                <div class="gift-header">
                    <h3>❄️ 立冬快乐呀 ❄️</h3>
                </div>
                <div class="gift-body">
                    <p>这是一份专属立冬礼物～</p>
                    <p>愿你冬日有暖，万事顺意</p>
                    <p>寒来暑往，秋收冬藏</p>
                    <p>愿所有美好都如期而至</p>
                </div>
                <button class="confirm-btn" @click="openNoteWall">打开我的心意 ✨</button>
            </div>
        </div>

        <!-- 便签墙容器（v-else确保弹窗消失后才渲染） -->
        <div id="board" v-else></div>
    </div>
</template>

<script>
export default {
    name: "popAllComponent",
    data() {
        return {
            board: null,
            messages: ["保持好心情", "多喝水哦", "今天辛苦啦", "早点休息", "记得吃水果", "加油，你可以的", "祝你顺利", "保持微笑呀", "愿所有烦恼都消失", "期待下一次见面", "梦想总会实现", "天气冷了，多穿衣服", "记得给自己放松", "每天都要元气满满", "今天也要好好爱自己", "适当休息一下", "立冬安康，温暖常伴", "冬日宜进补，也要常开心", "寒来添衣，别忘保暖", "愿冬日有光，温暖你我"],
            colors: ["#ffe0e3", "#c7f0ff", "#ffd8a8", "#d9f2d9", "#e5d7ff", "#f9f7d9", "#d2f0f8", "#ffd4f5"],
            cardStates: new WeakMap(),
            MAXIMIZED_LAYER: 1000000,
            activeMaximizedCard: null,
            isMobile: false,
            maxCards: 0,
            initialCardCount: 0,
            spawnInterval: 0,
            zIndexCursor: 200,
            spawnTimer: null,
            showGiftModal: true, // 控制弹窗显示
        };
    },
    mounted() {
        document.title = "妮美";
    },
    beforeDestroy() {
        if (this.spawnTimer) clearInterval(this.spawnTimer);
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        // 打开便签墙（核心修复：确保DOM更新后再操作board）
        openNoteWall() {
            this.showGiftModal = false; // 隐藏弹窗，显示board

            // 关键修复：使用$nextTick确保board元素已渲染到DOM中
            this.$nextTick(() => {
                this.initConfig();
                this.board = document.getElementById("board");

                // 双重校验：确保board存在再执行后续操作
                if (this.board) {
                    this.createInitialCards();
                    this.startAutoSpawn();
                    this.bindResizeEvent();
                } else {
                    console.error("未找到board元素，请检查模板是否正确");
                }
            });
        },
        initConfig() {
            this.isMobile = window.matchMedia("(pointer: coarse)").matches || window.innerWidth <= 768;
            this.maxCards = this.isMobile ? 120 : 180;
            this.initialCardCount = this.isMobile ? 18 : 30;
            this.spawnInterval = this.isMobile ? 700 : 400;
            document.body.classList.toggle("is-mobile", this.isMobile);
        },
        randomFrom(array) {
            return array[Math.floor(Math.random() * array.length)];
        },
        clamp(value, min, max) {
            return Math.min(Math.max(value, min), max);
        },
        applyTransform(card, state) {
            const scale = state.scale ?? 1;
            const translateX = state.translateX ?? 0;
            const translateY = state.translateY ?? 0;
            const angle = state.angle ?? 0;
            card.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale}) rotate(${angle}deg)`;
        },
        bringToFront(card) {
            if (card === this.activeMaximizedCard) {
                card.style.zIndex = this.MAXIMIZED_LAYER;
                return;
            }
            this.zIndexCursor += 1;
            if (this.activeMaximizedCard && this.zIndexCursor >= this.MAXIMIZED_LAYER) {
                this.zIndexCursor = this.MAXIMIZED_LAYER - 1;
            }
            card.style.zIndex = this.zIndexCursor;
        },
        setupCardInteractions(card) {
            const header = card.querySelector(".card-header");
            const closeBtn = card.querySelector(".control.close");
            const minimizeBtn = card.querySelector(".control.minimize");
            const maximizeBtn = card.querySelector(".control.maximize");

            closeBtn.addEventListener("click", (event) => {
                event.stopPropagation();
                this.closeCard(card);
            });

            minimizeBtn.addEventListener("click", (event) => {
                event.stopPropagation();
                this.minimizeCard(card);
            });

            maximizeBtn.addEventListener("click", (event) => {
                event.stopPropagation();
                this.toggleMaximize(card);
            });

            header.addEventListener("pointerdown", (event) => {
                if (event.pointerType === "touch") return;
                this.startDrag(event, card);
            });

            card.addEventListener("pointerdown", () => {
                this.bringToFront(card);
            });

            header.addEventListener("dblclick", (event) => {
                if (!event.target.closest(".control")) {
                    this.toggleMaximize(card);
                }
            });
        },
        closeCard(card) {
            const state = this.cardStates.get(card);
            if (!state || state.closing) return;

            if (card === this.activeMaximizedCard) {
                this.activeMaximizedCard = null;
            }

            state.closing = true;
            state.scale = 0.1;
            card.style.opacity = "0";
            this.applyTransform(card, state);

            const handleTransitionEnd = (event) => {
                if (event.propertyName === "opacity") {
                    card.removeEventListener("transitionend", handleTransitionEnd);
                    card.remove();
                }
            };

            card.addEventListener("transitionend", handleTransitionEnd);
        },
        minimizeCard(card) {
            const state = this.cardStates.get(card);
            if (!state || state.closing) return;

            const runMinimize = () => {
                state.closing = true;
                this.bringToFront(card);
                const bottom = Math.max(window.innerHeight - 24, 0);
                const targetLeft = this.clamp(state.left, 16, Math.max(window.innerWidth - card.offsetWidth - 16, 16));

                state.left = targetLeft;
                state.top = bottom;
                state.scale = 0.1;
                state.angle = 0;
                card.style.left = `${targetLeft}px`;
                card.style.top = `${bottom}px`;
                card.style.opacity = "0.35";
                this.applyTransform(card, state);

                const handleTransitionEnd = (event) => {
                    if (event.propertyName === "transform") {
                        card.removeEventListener("transitionend", handleTransitionEnd);
                        card.remove();
                    }
                };

                card.addEventListener("transitionend", handleTransitionEnd);
            };

            if (state.maximized) {
                this.activeMaximizedCard = null;
                state.maximized = false;
                card.classList.remove("maximized");
                card.style.borderRadius = "12px";
                state.left = 0;
                state.top = 0;
                state.scale = 1;
                state.angle = 0;
                this.applyTransform(card, state);

                requestAnimationFrame(() => {
                    requestAnimationFrame(runMinimize);
                });
                return;
            }

            runMinimize();
        },
        toggleMaximize(card) {
            const state = this.cardStates.get(card);
            if (!state || state.closing) return;

            if (state.maximized) {
                this.restoreFromMaximize(card, state);
            } else {
                this.maximizeCard(card, state);
            }
        },
        maximizeCard(card, state) {
            state.beforeMaximize = {
                left: state.left,
                top: state.top,
                scale: state.scale ?? 1,
                width: card.offsetWidth,
                height: card.offsetHeight,
                angle: state.angle ?? 0,
            };

            card.classList.add("maximized");
            card.style.left = "0px";
            card.style.top = "0px";
            card.style.width = `${window.innerWidth}px`;
            card.style.height = `${window.innerHeight}px`;
            card.style.borderRadius = "0";

            state.left = 0;
            state.top = 0;
            state.scale = 1;
            state.angle = 0;
            this.applyTransform(card, state);
            this.activeMaximizedCard = card;
            this.bringToFront(card);
            state.maximized = true;
        },
        restoreFromMaximize(card, state) {
            const previous = state.beforeMaximize;
            if (!previous) return;

            card.classList.remove("maximized");
            card.style.left = `${previous.left}px`;
            card.style.top = `${previous.top}px`;
            card.style.width = `${previous.width}px`;
            card.style.height = `${previous.height}px`;
            card.style.borderRadius = "12px";

            state.left = previous.left;
            state.top = previous.top;
            state.scale = previous.scale ?? 1;
            state.angle = previous.angle ?? state.angle ?? 0;
            this.applyTransform(card, state);
            state.maximized = false;

            if (this.activeMaximizedCard === card) {
                this.activeMaximizedCard = null;
            }

            this.bringToFront(card);
            state.lastPosition = { left: state.left, top: state.top };

            setTimeout(() => {
                if (!state.maximized) {
                    card.style.width = "";
                    card.style.height = "";
                    state.width = card.offsetWidth;
                    state.height = card.offsetHeight;
                }
            }, 360);
        },
        startDrag(event, card) {
            const control = event.target.closest(".control");
            if (control) return;

            const state = this.cardStates.get(card);
            if (!state || state.closing || state.maximized) return;

            event.preventDefault();
            this.bringToFront(card);

            const header = card.querySelector(".card-header");
            card.classList.add("dragging");
            header.classList.add("dragging");

            state.dragging = true;
            state.dragOffsetX = event.clientX - state.left;
            state.dragOffsetY = event.clientY - state.top;

            let dragFrame = null;
            let pendingLeft = state.left;
            let pendingTop = state.top;

            const commitDrag = () => {
                dragFrame = null;
                const maxLeft = Math.max(window.innerWidth - card.offsetWidth, 0);
                const maxTop = Math.max(window.innerHeight - card.offsetHeight, 0);
                state.left = this.clamp(pendingLeft, -card.offsetWidth * 0.4, maxLeft);
                state.top = this.clamp(pendingTop, -card.offsetHeight * 0.4, maxTop);
                card.style.left = `${state.left}px`;
                card.style.top = `${state.top}px`;
            };

            const handlePointerMove = (moveEvent) => {
                if (!state.dragging) return;

                pendingLeft = moveEvent.clientX - state.dragOffsetX;
                pendingTop = moveEvent.clientY - state.dragOffsetY;
                if (dragFrame === null) {
                    dragFrame = requestAnimationFrame(commitDrag);
                }
            };

            const handlePointerUp = () => {
                state.dragging = false;
                state.lastPosition = { left: state.left, top: state.top };
                card.classList.remove("dragging");
                header.classList.remove("dragging");

                if (dragFrame !== null) {
                    cancelAnimationFrame(dragFrame);
                    commitDrag();
                }

                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp);
            };

            document.addEventListener("pointermove", handlePointerMove);
            document.addEventListener("pointerup", handlePointerUp);
        },
        createCard() {
            // 再次校验board是否存在，避免意外错误
            if (!this.board) {
                console.error("board元素不存在，无法创建卡片");
                return;
            }

            const card = document.createElement("div");
            card.className = "card";

            const color = this.randomFrom(this.colors);
            const angleRange = this.isMobile ? 6 : 10;
            const angle = (Math.random() - 0.5) * angleRange;
            const cardWidth = this.isMobile ? 180 : 220;
            const cardHeight = this.isMobile ? 130 : 140;
            const horizontalMargin = this.isMobile ? 12 : 16;
            const verticalMargin = this.isMobile ? 12 : 20;

            const left = horizontalMargin + Math.random() * Math.max(window.innerWidth - cardWidth - horizontalMargin * 2, 0);
            const top = verticalMargin + Math.random() * Math.max(window.innerHeight - cardHeight - verticalMargin * 2, 0);

            card.style.background = color;
            card.style.left = `${left}px`;
            card.style.top = `${top}px`;

            if (this.activeMaximizedCard && this.zIndexCursor >= this.MAXIMIZED_LAYER - 2) {
                this.zIndexCursor = this.MAXIMIZED_LAYER - 2;
            }

            card.style.zIndex = ++this.zIndexCursor;

            card.innerHTML = `
        <div class="card-header">
          <div class="window-controls">
            <button class="control close" type="button" aria-label="关闭"></button>
            <button class="control minimize" type="button" aria-label="最小化"></button>
            <button class="control maximize" type="button" aria-label="最大化"></button>
          </div>
          <div class="card-title">立冬祝福</div>
        </div>
        <div class="card-body">${this.randomFrom(this.messages)}</div>
      `;

            const state = {
                angle,
                scale: this.isMobile ? 0.85 : 0.7,
                translateX: 0,
                translateY: 0,
                left,
                top,
                maximized: false,
                closing: false,
                lastPosition: { left, top },
            };

            this.cardStates.set(card, state);
            this.applyTransform(card, state);
            this.board.appendChild(card); // 这里之前因board为null报错，现在已修复

            state.width = card.offsetWidth;
            state.height = card.offsetHeight;

            requestAnimationFrame(() => {
                state.scale = 1;
                this.applyTransform(card, state);
                card.style.opacity = "1";
            });

            this.setupCardInteractions(card);

            if (this.board.children.length > this.maxCards) {
                const oldest = this.board.firstElementChild;
                if (oldest && oldest !== card) {
                    oldest.remove();
                }
            }
        },
        createInitialCards() {
            for (let i = 0; i < this.initialCardCount; i++) {
                setTimeout(() => this.createCard(), i * (this.isMobile ? 60 : 40));
            }
        },
        startAutoSpawn() {
            this.spawnTimer = setInterval(() => this.createCard(), this.spawnInterval);
        },
        handleResize() {
            const newIsMobile = window.matchMedia("(pointer: coarse)").matches || window.innerWidth <= 768;
            if (newIsMobile !== this.isMobile) {
                this.initConfig();
            }
            document.querySelectorAll(".card.maximized").forEach((card) => {
                card.style.width = `${window.innerWidth}px`;
                card.style.height = `${window.innerHeight}px`;
            });
        },
        bindResizeEvent() {
            window.addEventListener("resize", this.handleResize);
        },
    },
};
</script>

<style>
/* 样式保持不变 */
:root {
    --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    --transition-fast: all 0.2s ease;
    --transition-slow: all 0.5s ease;
    --primary-color: #151513;
    --primary-dark: #333;
    --winter-color: #ff7e67;
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    background-image: linear-gradient(0deg, #eee 1px, transparent 0), linear-gradient(90deg, #eee 1px, transparent 0);
    background-size: 30px 30px;
    color: #333;
    min-height: 100dvh;
    overflow: hidden;
}

body.is-mobile {
    overflow-y: auto;
}

#board {
    position: relative;
    width: 100vw;
    height: 100dvh;
    overflow: hidden;
}

body.is-mobile #board {
    height: auto;
    min-height: 100dvh;
}

.gift-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999999;
    backdrop-filter: blur(5px);
}

.gift-content {
    width: 90%;
    max-width: 450px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(255, 126, 103, 0.2);
    padding: 30px 20px;
    text-align: center;
    border: 2px solid var(--winter-color);
    position: relative;
    overflow: hidden;
}

.gift-content::before {
    content: "❄️";
    position: absolute;
    top: 10px;
    left: 10px;
    font-size: 24px;
}

.gift-content::after {
    content: "🍂";
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 24px;
}

.gift-header h3 {
    color: var(--winter-color);
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: 700;
}

.gift-body p {
    font-size: 18px;
    margin: 10px 0;
    color: #555;
    line-height: 1.6;
}

.confirm-btn {
    margin-top: 30px;
    padding: 12px 36px;
    background: var(--winter-color);
    color: #fff;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: 0 4px 15px rgba(255, 126, 103, 0.3);
}

.confirm-btn:hover {
    background: #ff6b52;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 126, 103, 0.4);
}

.card {
    position: absolute;
    width: 220px;
    border-radius: 12px;
    box-shadow: 0 16px 35px rgba(0, 0, 0, 0.2);
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    overflow: hidden;
    opacity: 0;
    transform-origin: center;
    transition: transform 0.35s ease, opacity 0.35s ease, left 0.35s ease, top 0.35s ease, width 0.35s ease, height 0.35s ease, border-radius 0.35s ease;
}

.card.dragging {
    transition: none;
    box-shadow: 0 22px 45px rgba(0, 0, 0, 0.35);
}

.card.maximized {
    box-shadow: 0 28px 60px rgba(0, 0, 0, 0.4);
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    background: rgba(255, 255, 255, 0.7);
    cursor: grab;
    user-select: none;
    touch-action: pan-y;
}

.card-header.dragging {
    cursor: grabbing;
}

.window-controls {
    display: flex;
    align-items: center;
    gap: 6px;
}

.window-controls .control {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: #ccc;
    cursor: pointer;
    outline: none;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.window-controls .control.close {
    background: #ff5f57;
    border-color: #e0443e;
}

.window-controls .control.minimize {
    background: #febb2e;
    border-color: #dea123;
}

.window-controls .control.maximize {
    background: #28c840;
    border-color: #1aab2c;
}

.window-controls .control::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s ease;
}

.card-header:hover .window-controls .control::after {
    opacity: 0.8;
}

.window-controls .control.close::after {
    content: "×";
    width: auto;
    height: auto;
    background: none;
    font-size: 10px;
    line-height: 1;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.7);
}

.window-controls .control.minimize::after {
    width: 6px;
    height: 2px;
    background: rgba(0, 0, 0, 0.6);
}

.window-controls .control.maximize::after {
    width: 6px;
    height: 6px;
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.6) 45%, transparent 45%, transparent 55%, rgba(0, 0, 0, 0.6) 55%, rgba(0, 0, 0, 0.6) 100%);
}

.card-title {
    font-size: 13px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.55);
    padding-left: 10px;
    flex: 1;
}

.card-body {
    padding: 16px;
    font-size: 16px;
    line-height: 1.4;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.72);
}

@media (max-width: 768px) {
    .card {
        width: 180px;
        border-radius: 10px;
    }

    .card-body {
        padding: 14px;
        font-size: 14px;
    }

    .card-title {
        font-size: 12px;
    }

    .gift-header h3 {
        font-size: 20px;
    }

    .gift-body p {
        font-size: 16px;
    }

    .confirm-btn {
        padding: 10px 28px;
        font-size: 14px;
    }
}
</style>
